import React, { useState, useEffect } from "react";
import "../assets/css/Contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [contactInfo, setContactInfo] = useState(null);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setSuccess("Message sent successfully!");
        setError("");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setError(data.message || "Failed to send message");
        setSuccess("");
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
      setSuccess("");
    }
  };
  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/contact-info`);
        const data = await res.json();
        setContactInfo(data);
      } catch (err) {
        console.error("Failed to load contact info");
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[
          { label: "Home", to: "/" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <div className="contact-page">
        {/* Hero Section */}
        <div className="contact-hero">
          <h1>Get in Touch with Us</h1>
          <p>
            We are here to assist you. Reach out for product information, partnership, or general inquiries.
            Our team is committed to providing timely responses.
          </p>
          <div className="contact-info-cards">
            <div className="info-card">
              <FaPhoneAlt className="info-icon" />
              <h4>Call Us</h4>
              {/* <p>(+91) 7776070000</p> */}
              <p>{contactInfo?.phone}</p>

            </div>
            <div className="info-card">
              <FaEnvelope className="info-icon" />
              <h4>Email</h4>
              {/* <p>admin@biocieaa.com</p> */}
              <p>{contactInfo?.email}</p>

            </div>
            <div className="info-card">
              <FaMapMarkerAlt className="info-icon" />
              <h4>Location</h4>
              {/* <p>Hadpsar, Hadapsar - Saswad - Jejuri Rd, near Gayatri sadi centre, Mantarwadi, Pune, 412308</p> */}
              <p>{contactInfo?.address}</p>

            </div>
          </div>
        </div>

        {/* Contact Form + Map */}
        <div className="contact-wrapper">
          <div className="form-section">
            <h2>Contact Us</h2>
            <p>Have questions? We'd love to hear from you.</p>
            <form onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button type="submit">Send Message</button>
            </form>
            {success && <p className="success">{success}</p>}
            {error && <p className="error">{error}</p>}
          </div>

          <div className="map-section">
            <h3>Our Location</h3>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.4253236265677!2d73.96025007501173!3d18.464383882618314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e99c2661443f%3A0xa486c41406947c93!2sBiopharmacieaa%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1764190503632!5m2!1sen!2sin"
              width="100%"
              height="300"
              frameBorder="0"
              allowFullScreen=""
              loading="lazy"
            ></iframe>

          </div>
        </div>

        {/* Social Media Section */}
        <div className="social-section">
          <h2>Connect with Us</h2>
          <p>Follow us on social media to stay updated with our latest news and products.</p>
          <div className="social-icons">
            {/* <a href="https://www.linkedin.com/company/80816437/admin/dashboard/" className="social-icon linkedin" target="_blank"><FaLinkedin /></a> */}
            <a href={contactInfo?.linkedin} className="social-icon linkedin" target="_blank"><FaLinkedin /></a>
            {/* <a href="#" className="social-icon twitter"><FaTwitter /></a> */}
            {/* <a href="https://www.facebook.com/GeoMediCs.Pharma/" className="social-icon facebook" target="_blank"><FaFacebook /></a> */}
            <a href={contactInfo?.facebook} className="social-icon facebook" target="_blank"><FaFacebook /></a>
            {/* <a href="https://www.instagram.com/geobio_family/" className="social-icon instagram" target="_blank"><FaInstagram /></a> */}
            <a href={contactInfo?.instagram} className="social-icon instagram" target="_blank"><FaInstagram /></a>
          </div>
        </div>
      </div>

    </>

  );
};

export default Contact;
